jQuery(document).ready(function(){
  jQuery(".collectionSliderSection").on("click", ".item", function(){
    // Perform the action you want instead of triggering a click event
    var collectionInfoLink = jQuery(this).find('.collectionInfo a').attr('href');
    
    // Example: Redirect to the link
    window.location.href = collectionInfoLink;
  });
});

jQuery(document).ready(function(){
  if(ShopifyAnalytics.meta.page.customerId ){
      jQuery('a[href="/account"].menu-lv-2__action span').text('Logout');
      jQuery('a[href="/account"].menu-lv-2__action').attr('href','/account/logout');
      jQuery('li[data-url*="/account/register"].menu-lv-2').hide();
  }else{
      jQuery('li[data-url*="/a/saved-carts"].menu-lv-2').hide();
      jQuery('li[data-url*="/tools/recurring/login"].menu-lv-2').hide();
  }
});
/* BELOW IS FUNCTION TO ADD PRODUCT*/
                   
function addToCart(variant_id, selling_plan, qty) {
    // Optional: Clear the cart before adding an item
// event.preventDefault();
    // Call the addItemToCart function
    addItemToCart(variant_id, qty, selling_plan);
}

function clearCart() {
    jQuery.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        dataType: 'json',
        success: function () {
            console.log('Cart cleared successfully.');
            
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.error('Error clearing cart:', errorThrown);
        }
    });
}

function addItemToCart(variant_id, qty, selling_plan) {
    var data = {
        "id": variant_id,
        "quantity": qty,
        "selling_plan": selling_plan
    };

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
            console.log('Item added to cart successfully.');
           // window.location.href = '/cart';

        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.error('Error adding item to cart:', errorThrown);
        }
    });
}
